<template>
  <div>
    <div class="data">
        {{ data }}
    </div>
    <div class="label">
        {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.data {
  font-size: 30px;
  font-family: Lato;
  font-weight: 700;
  font-style: normal;
  color: #4369F4;
  padding: 8px;
}

.label {
  font-size: 12px;
  font-family: Lato;
  font-weight: 500;
  font-style: normal;
  color: #778699;
  text-transform: uppercase;
}
</style>

